import { Text, View, Image } from 'components';
import { Modal } from 'components/Modal';
// import Modal from 'react-modal';
import Base, { Config } from 'components/megatron/Base';
import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


interface Props {
  visible: boolean
  jid?: number    //招聘ID
  onClose: () => void
  onSuccess?: () => void
}

interface Item {
  id: number;
  value: number;
  name: string;
  price: number | string;
  origin_price?: number | string;
  gift?: number
}

interface State {
  items: Item[];
  selectedIndex: number;
  scores: number;
}

const SMALLTEXT = ['获得600倍曝光', '低至149元/天']

export default class BuyTopModal extends Base<Props, State> {
  public state: State = {
    items: [],
    scores: 0,
    selectedIndex: 0
  };

  public didMount(){
    // console.log("????")
    if (this.state.items.length === 0) {
      this.fetchItems();
    }
  }

  public render() {
    const { visible } = this.props
    const { items, selectedIndex } = this.state;

    return (
      <Modal className={styles.modal} isOpen={visible} shouldCloseOnOverlayClick={true} onRequestClose={this.handleCloseFunc}>
        
        <View className={styles.title}>选择你要置顶的时间</View>
        <View className={styles.buyBox}>
          {items.map((item, index) => (
            <View
              key={index}
              onClick={this.handleSelectItem.bind(this, index)}
              className={cx(
                styles.item,
                index === selectedIndex ? styles.active : ''
              )}
            >
              <Text className={styles.day}>置顶{item.value}天</Text>
              <Text className={styles.scores}>
                {Number(item.price).toFixed(0)}元
              </Text>
              <Text className={styles.small}>
                {SMALLTEXT[index]}
              </Text>
            </View>
          ))}
        </View>
        <View className={styles.btns}>
          <View className={styles.btn} onClick={this.handleCloseFunc}>取消</View>
          <View className={cx(styles.btn, styles.blue)} onClick={this.handleConfirm}>{this.confirmText}</View>
        </View>
      </Modal>
    );
  }

  private handleSelectItem = index => {
    this.setState({
      selectedIndex: index
    });
  }

  private get selectedItem() {
    const { items, selectedIndex } = this.state;

    return items[selectedIndex] || {};
  }

  private get confirmText() {
    return `点此置顶${this.selectedItem.value || 0}天`;
  }

  private handleCloseFunc = () => {
    this.props.onClose()
  }
  
  private fetchItems = async () => {
    const { body } = await this.apiClient.base.scoresRechargeList({ type: 2 });
    const selectedIndex = body.findIndex(item => item.selected);

    this.setState({
      items: body,
      selectedIndex: selectedIndex !== -1 ? selectedIndex : 0
    });
  }

  private handleConfirm = async() => {
    const { jid } = this.props
    const {status, body, msg} = await this.apiClient.base.jobToTop({
      id: this.selectedItem.id,
      jid
    })
    if(status != 10000){
      
      toast.error(msg, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
      return;
    }

    const paymentConfig = {
      appId: body.appId,
      nonceStr: body.nonceStr,
      package: body.package,
      paySign: body.paySign,
      signType: body.signType,
      timestamp: body.timeStamp
    };

    this.interface.requestPayment(paymentConfig).then(res => {
      if (res.errMsg === 'chooseWXPay:ok') {
        toast.success('置顶成功！可前往小程序查看',{
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1500,
          closeButton: false,
        })
        this.props.onClose()
        const { onSuccess } = this.props;
        if (typeof onSuccess === 'function') {
          onSuccess();
        }
      }
    }).catch(err => {
      console.log(err)
      toast.error('置顶失败！',{
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500,
        closeButton: false,
      })
    });



  }
}
